export const apiPath = '/v2/incident_templates';
const actionType = 'INCIDENT_TEMPLATE';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
